import { SectionHeading } from './SectionHeading'

// "About Jnati" — 4 verbatim paragraphs from marketing (#7r2).
// Justified body text matching marketing's `textAlign: justify`.
// First mention of "Jnati" wrapped in <strong> per marketing.

export function AboutSection() {
  return (
    <section id="about" className="py-12 sm:py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <SectionHeading>About Jnati</SectionHeading>
        <div className="mt-8 space-y-5 text-white/90 text-sm sm:text-base leading-relaxed text-justify">
          <p>
            <strong className="text-gold">Jnati</strong> is a private digital platform designed to help you map, connect, and grow your family network. Whether it&apos;s your close relatives or extended family, Jnati makes it easy to discover and build meaningful relationships across generations.
          </p>
          <p>
            Our goal is to preserve your family&apos;s legacy and stories, while enabling secure and private sharing within trusted circles. We use smart suggestions, name searches, parent&apos;s name searches, location-based searches, and secure connection requests to help you grow your network safely. Jnati respects your privacy — there are no public posts, no exposure to strangers, and everything stays within your invited family tree. Even you can create your own circles among your family members network.
          </p>
          <p>
            With Jnati, you can invite relatives, verify relationships, build dynamic family graphs, and store important details for future generations. Whether you&apos;re building your family tree from scratch or expanding existing connections, Jnati empowers you with a beautiful, intuitive, and private experience.
          </p>
          <p>
            We&apos;re here to strengthen bonds, revive lost connections, and make family mapping a joyful journey.
          </p>
        </div>
      </div>
    </section>
  )
}
